import { render, staticRenderFns } from "./ProjectPin.vue?vue&type=template&id=0d403a88&scoped=true&lang=pug&"
import script from "./ProjectPin.vue?vue&type=script&lang=js&"
export * from "./ProjectPin.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPin.vue?vue&type=style&index=0&id=0d403a88&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d403a88",
  null
  
)

export default component.exports